module.exports = __webpack_public_path__ + "static/brand-bottom-dfc7fbb002a3cae95012426ab85f7205.webp";